onClearStore